module.exports = __webpack_public_path__ + "static/img/brees-2015-top.f443616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-top.jpg
// module id = lTjf
// module chunks = 1